module.exports = __webpack_public_path__ + "img/113.56d44728.gif";